/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Rut_GInputs */

const en_mk_tut_rut_g = /** @type {(inputs: Mk_Tut_Rut_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work that repeats every day or every week should not need remembering.`)
};

const id_mk_tut_rut_g = /** @type {(inputs: Mk_Tut_Rut_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pekerjaan yang berulang tiap hari atau tiap minggu sebaiknya tidak perlu Anda ingat.`)
};

/**
* | output |
* | --- |
* | "Work that repeats every day or every week should not need remembering." |
*
* @param {Mk_Tut_Rut_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_rut_g = /** @type {((inputs?: Mk_Tut_Rut_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Rut_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_rut_g(inputs)
	return en_mk_tut_rut_g(inputs)
});